import { Archive, Check, MagnifyingGlass, Warning } from "@phosphor-icons/react"
import { Button } from "@tokenterminal/core/ui/button/Button"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { TextField } from "@tokenterminal/core/ui/input/TextField"

interface ChainStatusFiltersProps {
  statusFilter: "all" | "fresh" | "stale" | "archived"
  setStatusFilter: (filter: "all" | "fresh" | "stale" | "archived") => void
  searchQuery: string
  setSearchQuery: (query: string) => void
  stats: {
    total: number
    fresh: number
    stale: number
    archived: number
  }
}

export function ChainStatusFilters({
  statusFilter,
  setStatusFilter,
  searchQuery,
  setSearchQuery,
  stats,
}: ChainStatusFiltersProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="flex flex-wrap gap-2">
          <Button
            variant={statusFilter === "all" ? "muted" : "ghost"}
            onPress={() => setStatusFilter("all")}
            size="small"
            className="flex items-center gap-2"
          >
            All
            <span
              className={`text-xs ${statusFilter === "all" ? "bg-neutral-50 dark:bg-neutral-900" : "bg-neutral-100 dark:bg-neutral-800"} px-2 py-0.5 rounded-full`}
            >
              {stats.total}
            </span>
          </Button>

          <Button
            variant={statusFilter === "fresh" ? "muted" : "ghost"}
            onPress={() => setStatusFilter("fresh")}
            size="small"
            className="flex items-center gap-2"
          >
            <Icon as={Check} className="text-success-fg" width={16} />
            Fresh
            <span
              className={`text-xs ${statusFilter === "fresh" ? "bg-neutral-50 dark:bg-neutral-900" : "bg-neutral-100 dark:bg-neutral-800"} px-2 py-0.5 rounded-full`}
            >
              {" "}
              {stats.fresh}
            </span>
          </Button>

          <Button
            variant={statusFilter === "stale" ? "muted" : "ghost"}
            onPress={() => setStatusFilter("stale")}
            size="small"
            className="flex items-center gap-2"
          >
            <Icon as={Warning} className="text-warning-fg" width={16} />
            Stale
            <span
              className={`text-xs ${statusFilter === "stale" ? "bg-neutral-50 dark:bg-neutral-900" : "bg-neutral-100 dark:bg-neutral-800"} px-2 py-0.5 rounded-full`}
            >
              {" "}
              {stats.stale}
            </span>
          </Button>

          <Button
            variant={statusFilter === "archived" ? "muted" : "ghost"}
            onPress={() => setStatusFilter("archived")}
            size="small"
            className="flex items-center gap-2"
          >
            <Icon as={Archive} className="text-fg-secondary" width={16} />
            Archived
            <span
              className={`text-xs ${statusFilter === "archived" ? "bg-neutral-50 dark:bg-neutral-900" : "bg-neutral-100 dark:bg-neutral-800"} px-2 py-0.5 rounded-full`}
            >
              {" "}
              {stats.archived}
            </span>
          </Button>
        </div>
      </div>
      <div className="grow w-full">
        <TextField
          placeholder="Search chains..."
          value={searchQuery}
          onChange={(value: string) => setSearchQuery(value)}
          slots={{
            leading: (
              <Icon
                as={MagnifyingGlass}
                className="text-fg-secondary"
                width={16}
              />
            ),
          }}
        />
      </div>
    </div>
  )
}
